import * as types from 'model/actionTypes'
import { AccountProfileT } from 'shared/types/model'

export function receiveAccountProfile (accountProfile: AccountProfileT | null) {
  return {
    type: types.RECEIVE_ACCOUNT_PROFILE,
    accountProfile
  }
}
